import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_DELETE_COLLECTION_VALIDATION_BEGIN,
  COLLECTIONS_DELETE_COLLECTION_VALIDATION_SUCCESS,
  COLLECTIONS_DELETE_COLLECTION_VALIDATION_FAILURE,
  COLLECTIONS_DELETE_COLLECTION_VALIDATION_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';

export function deleteCollectionValidation(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_DELETE_COLLECTION_VALIDATION_BEGIN,
    });

    const { projectId, collectionUuid, validationId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/validations/${collectionUuid}/collection/${validationId}`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: COLLECTIONS_DELETE_COLLECTION_VALIDATION_SUCCESS,
              data: res.data,
              collectionUuid,
            });
            Mixpanel.track('Deleted collection validation');
            toast.success('Deleted Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: COLLECTIONS_DELETE_COLLECTION_VALIDATION_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Failed to delete collection validation');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Deletion failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_DELETE_COLLECTION_VALIDATION_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to delete collection validation');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Deletion Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteCollectionValidationError() {
  return {
    type: COLLECTIONS_DELETE_COLLECTION_VALIDATION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_DELETE_COLLECTION_VALIDATION_BEGIN:
      return {
        ...state,
        deleteCollectionValidationPending: true,
        deleteCollectionValidationError: null,
      };

    case COLLECTIONS_DELETE_COLLECTION_VALIDATION_SUCCESS:
      let projectCollections = state.projectCollections;
      let index = projectCollections.findIndex((item) => {
        return item.uuid === action.collectionUuid;
      });
      if (index !== -1) {
        projectCollections[index].validations = action.data;
      }
      return {
        ...state,
        deleteCollectionValidationPending: false,
        deleteCollectionValidationError: null,
        projectCollections,
        selectedCollection: {
          ...state.selectedCollection,
          validations: action.data,
        },
      };

    case COLLECTIONS_DELETE_COLLECTION_VALIDATION_FAILURE:
      return {
        ...state,
        deleteCollectionValidationPending: false,
        deleteCollectionValidationError: action.data.error,
      };

    case COLLECTIONS_DELETE_COLLECTION_VALIDATION_DISMISS_ERROR:
      return {
        ...state,
        deleteCollectionValidationError: null,
      };

    default:
      return state;
  }
}
